import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';
import CrudContext from 'react/contexts/DefaultContext';

class ColorPickerField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      monetField: null
    };
  }

  componentDidMount() {
    const {
      label,
      monetMeta
    } = this.props;

    const { entity } = this.context;

    this.setState({
      monetField: new Monet.UI.Fields.Render({
        label,
        type: 'COLOR',
        meta: monetMeta
      }, entity).render()
    });
  }

  renderFieldContent = ({
    ref,
    input,
    monetField
  }) => {
    if (monetField) {
      const onChange = () => {
        const value = monetField.getValue();
        input.onChange(value);
      };
      monetField.setValue(input.value);

      monetField.input.onchange = onChange;
    }

    return (
      <div
        ref={ref}
      />
    );
  };

  render() {
    const { defaultValue } = this.props;
    const { monetField } = this.state;

    return (
      <BaseField
        fieldClassName="colorpicker"
        monetField={monetField}
        renderFieldContent={this.renderFieldContent}
        type="color"
        defaultValue={defaultValue}
        {...this.props}
      />
    );
  }
}

ColorPickerField.contextType = CrudContext;

ColorPickerField.propTypes = {
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  monetMeta: PropTypes.shape({
    showPaletteOnly: PropTypes.bool,
    showSelectionPalette: PropTypes.bool,
    palette: PropTypes.array
  })
};

ColorPickerField.defaultProps = {
  defaultValue: '#1469BA',
  monetMeta: {
    showPaletteOnly: true,
    showSelectionPalette: false,
    palette: [
      ['#1469BA', '#07B5B7', '#5FA0CC', '#AC80E9', '#F2AB03'],
      ['#FF6700', '#FF3F22', '#FF4952', '#39A348', '#8AB03F']
    ]
  }
};

export default ColorPickerField;
